import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootContainer: {
    display: 'flex',
    minWidth: theme.spacing(83),
    padding: theme.spacing(4),
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(4),
    borderRadius: theme.spacing(1),
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.textField.light}`,
    overflow: 'auto',
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      width: '457px',
    },
    [theme.breakpoints.between('md', 'xl')]: {
      width: '296px',
    },
    alignItems: 'flex-start',
    marginRight: theme.spacing(0),
    marginLeft: theme.spacing(0),
  },
  heading: {
    fontSize: '22px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px !important',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
  },
  videoContainer: {
    backgroundColor: theme.palette.bgPrimary.main,
    width: '254px !important',
    [theme.breakpoints.up('lg')]: {
      width: '425px !important',
    },
    [theme.breakpoints.between('md', 'xl')]: {
      width: '254px !important',
    },
    textAlign: 'left',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
  },
  thumbnailImages: {
    width: '142px',
    height: '72px',
    cursor: 'pointer',
    marginBottom: theme.spacing(1.125),
    borderRadius: theme.spacing(0.4),
  },
  description: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '664px',
    height: '440px',
    maxWidth: '664px',
    margin: '1px auto',
  },
  divider: {
    backgroundColor: '#B0BDC2',
    borderRadius: '4px',
    display: 'flex',
    width: '1px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    margin: theme.spacing(0),
  },
}))
